import Content from "uxp-documentation/src/pages/uxp-api/reference-css/Styles/justify-content";
import * as React from 'react';
export default {
  Content,
  React
};